export interface MockApplicant {
  id: number;
  user_id: number;
  nin: string;
  nin_status: 'PENDING' | 'VERIFIED' | 'NO_MATCH';
  account_status: 'ACTIVE' | 'SUSPENDED';
  
  // Personal Information
  first_name: string;
  middle_name?: string;
  last_name: string;
  dob: string; // YYYY-MM-DD
  pob_city?: string;
  nationality?: string;
  
  // Physical Characteristics
  sex?: 'M' | 'F';
  height_cm?: number;
  weight_kg?: number;
  
  // Contact
  phone?: string;
  email?: string;
  
  // Address
  address_line1?: string;
  city?: string;
  state?: string;
  country?: string;
  
  // Employment
  employer?: string;
  
  // Metadata
  created_at: string;
  updated_at: string;
}

export const mockApplicants: MockApplicant[] = [
  {
    id: 1,
    user_id: 2,
    nin: "12345678901",
    nin_status: "VERIFIED",
    account_status: "ACTIVE",
    first_name: "John",
    middle_name: "Chukwuma",
    last_name: "Okafor",
    dob: "1995-03-15",
    pob_city: "Lagos",
    nationality: "Nigerian",
    sex: "M",
    height_cm: 175,
    weight_kg: 72,
    email: "applicant@test.com",
    phone: "+234-801-234-5678",
    address_line1: "12 Victoria Island Road",
    city: "Lagos",
    state: "Lagos",
    country: "Nigeria",
    employer: "Nigeria Airways",
    created_at: "2024-01-15T10:30:00Z",
    updated_at: "2024-09-20T14:22:00Z"
  },
  {
    id: 2,
    user_id: 4,
    nin: "23456789012",
    nin_status: "VERIFIED",
    account_status: "ACTIVE",
    first_name: "Amina",
    middle_name: "Zainab",
    last_name: "Bello",
    dob: "1992-07-22",
    pob_city: "Abuja",
    nationality: "Nigerian",
    sex: "F",
    height_cm: 168,
    weight_kg: 65,
    email: "amina.bello@example.com",
    phone: "+234-802-345-6789",
    address_line1: "45 Maitama District",
    city: "Abuja",
    state: "FCT",
    country: "Nigeria",
    employer: "Aero Contractors",
    created_at: "2024-02-10T08:15:00Z",
    updated_at: "2024-10-01T10:30:00Z"
  },
  {
    id: 3,
    user_id: 5,
    nin: "34567890123",
    nin_status: "PENDING",
    account_status: "SUSPENDED",
    first_name: "Emmanuel",
    last_name: "Eze",
    dob: "1998-11-30",
    pob_city: "Port Harcourt",
    nationality: "Nigerian",
    sex: "M",
    height_cm: 180,
    weight_kg: 78,
    email: "emmanuel.eze@example.com",
    phone: "+234-803-456-7890",
    address_line1: "23 Trans Amadi",
    city: "Port Harcourt",
    state: "Rivers",
    country: "Nigeria",
    employer: "Dana Air",
    created_at: "2024-05-20T14:00:00Z",
    updated_at: "2024-09-15T16:45:00Z"
  },
  {
    id: 4,
    user_id: 6,
    nin: "45678901234",
    nin_status: "VERIFIED",
    account_status: "ACTIVE",
    first_name: "Fatima",
    middle_name: "Aisha",
    last_name: "Ibrahim",
    dob: "1990-04-18",
    pob_city: "Kano",
    nationality: "Nigerian",
    sex: "F",
    height_cm: 165,
    weight_kg: 60,
    email: "fatima.ibrahim@example.com",
    phone: "+234-804-567-8901",
    address_line1: "67 Sabon Gari",
    city: "Kano",
    state: "Kano",
    country: "Nigeria",
    employer: "Air Peace",
    created_at: "2024-03-12T11:20:00Z",
    updated_at: "2024-08-25T09:10:00Z"
  },
  {
    id: 5,
    user_id: 7,
    nin: "56789012345",
    nin_status: "VERIFIED",
    account_status: "ACTIVE",
    first_name: "Chidinma",
    middle_name: "Grace",
    last_name: "Nwosu",
    dob: "1996-09-05",
    pob_city: "Enugu",
    nationality: "Nigerian",
    sex: "F",
    height_cm: 170,
    weight_kg: 68,
    email: "chidinma.nwosu@example.com",
    phone: "+234-805-678-9012",
    address_line1: "89 Independence Layout",
    city: "Enugu",
    state: "Enugu",
    country: "Nigeria",
    employer: "Azman Air",
    created_at: "2024-06-08T13:45:00Z",
    updated_at: "2024-09-30T15:20:00Z"
  }
];

// Helper to get current logged-in applicant (ID 1)
export const getCurrentApplicant = (): MockApplicant => {
  return mockApplicants[0];
};
